import { render } from "./quiz-v1-self-assessment-results.vue?vue&type=template&id=108a8e7e&scoped=true"
import script from "./quiz-v1-self-assessment-results.vue?vue&type=script&lang=js"
export * from "./quiz-v1-self-assessment-results.vue?vue&type=script&lang=js"

import "./quiz-v1-self-assessment-results.vue?vue&type=style&index=0&id=108a8e7e&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108a8e7e"]])

export default __exports__